module.exports = __webpack_public_path__ + "img/78.fbe7ecbb.png";